<template>
  <div class="applyFor" :class="{'isiOSX':isiOSX}">
    <van-nav-bar v-if="isApp" title="代理商招募" :fixed="true" />
    <img v-if="isApp" @click="goBack()" class="reback" src="../../assets/myInvest/reback.png" />
    <van-row>
      <van-col span="24" class="head_image" :style="paddT">
        <img src="../../assets/advDetail/joinUs/bz28@2x.png" alt />
        <img src="../../assets/advDetail/joinUs/bz27@2x.png" alt />
      </van-col>
      <van-col span="24" class="benefit">
        <div class="benefit-content">
          <img class="benefit-top" src="../../assets/advDetail/joinUs/bzbf5@2x.png" alt />
          <div class="benefit_3">
            <div class="business">
              <div class="business-left">
                <div class="business-title">龙维金</div>
                <div class="business-content">
                  <img src="../../assets/advDetail/joinUs/weixin@2x.png" alt />
                  <p>xbsh012</p>
                </div>
              </div>
              <div class="business-right">
                <a href="tel:18258123935" @click="iOStel(18258123935)">
                  <img src="../../assets/advDetail/joinUs/dianhua@2x.png" />
                </a>
              </div>
            </div>
            <div class="business">
              <div class="business-left">
                <div class="business-title">李国利</div>
                <div class="business-content">
                  <img src="../../assets/advDetail/joinUs/weixin@2x.png" alt />
                  <p>xbsh3488</p>
                </div>
              </div>
              <div class="business-right">
                <a href="tel:13848663488" @click="iOStel(13848663488)">
                  <img src="../../assets/advDetail/joinUs/dianhua@2x.png" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </van-col>
    </van-row>
    <p class="btn">
      <a href="tel:4000571671" @click="iOStel(4000571671)">
        <img src="../../assets/advDetail/joinUs/bz4@2x.png" />
      </a>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tel: "",
      isApp: true,
      isiOSX: false,
      paddT: { paddingTop: "68px" } //app内
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.from) {
      //app外
      this.isApp = false;
      this.paddT = { paddingTop: "0" };
    } else {
      if (this.isiOSX) {
        //app内齐刘海
        this.paddT = { paddingTop: "88px" };
      }
    }
  },
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },
    iOStel(phoneString) {
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua) && !this.$route.query.from) {
        this.phone(phoneString);
      }
    },
    phone(phoneString) {
      this.tel = phoneString;
      this.params(this.tel, this.tel, "phone");
    }
  },
  mounted() {}
};
</script>

<style lang="less">
.applyFor {
  background: #ffe7ad;
  padding-bottom: 100px;
  min-height: 100%;
  .van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 24px;
    box-shadow: 0 1px 0 #eee;
    .van-nav-bar__title {
      color: #333;
      font-size: 17px;
      font-weight: 700;
    }
  }
  .reback {
    width: 15px;
    padding: 12px 15px;
    position: fixed;
    top: 27px;
    left: 0;
    z-index: 1;
  }
  .head_image {
    height: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .reback {
    width: 15px;
    padding: 12px 15px;
    position: fixed;
    top: 29px;
    left: 0;
    z-index: 2;
  }
  .benefit {
    .benefit-content {
      border-radius: 8px;
      background: #ffffff;
      margin: 13px 15px 0 15px;
      position: relative;
      padding-top: 22px;
      .benefit-top {
        margin-left: 50%;
        width: 224px;
        height: 43px;
        position: absolute;
        top: -17px;
        left: -112px;
        z-index: 2;
      }
      .benefit_3 {
        padding-top: 22px;
        padding-bottom: 2px;
        .business {
          display: flex;
          margin: 0px 20px 18px;
          background: #ffe7ad;
          border-radius: 6px;
          height: 80px;
          position: relative;
          .business-left {
            float: left;
            .business-title {
              color: #333333;
              font-size: 16px;
              font-weight: 600;
              position: absolute;
              top: 15px;
              left: 18px;
            }
            img {
              width: 20px;
              height: 20px;
              position: absolute;
              top: 45px;
              left: 18px;
            }
            p {
              display: inline-block;
              position: absolute;
              top: 45px;
              left: 46px;
              height: 20px;
              line-height: 20px;
            }
          }
          .business-right {
            float: right;
            width: 35px;
            position: absolute;
            top: 23px;
            right: 21px;
            a {
              img {
                width: 35px;
                height: 35px;
              }
            }
          }
        }
      }
    }
  }

  .btn {
    position: fixed;
    width: 345px;
    height: 50px;
    bottom: 15px;
    margin-left: 50%;
    left: -172.5px;
    z-index: 3;
    a {
      img {
        width: 345px;
        height: 50px;
      }
    }
  }
  .van-area {
    button {
      color: #333;
    }
  }
}
.isiOSX {
  .van-nav-bar {
    padding-top: 44px;
  }
  .reback {
    top: 49px;
  }
}
</style>
